<li
    id="{{ id }}"
    [class]="rclass"
    (click)="itemSelected()"
    [ngClass]="{'autocomplete__key': isSelected}"
    role="option"
    [attr.aria-selected]="isSelected ? true : null"
>
    {{label}}
</li>
